import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
}), 'Crop75TwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop75TwoTone.js
// module id = 3003
// module chunks = 2